import { FC } from 'react';
import { ReactComponent as InfoSvg } from 'resources/images/info.svg';
import {
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
  Icon,
} from '@chakra-ui/react';

interface OfflineDialogProps {
  subtitle: string;
  text: string;
}

export const OfflineDialog: FC<OfflineDialogProps> = ({ subtitle, text }) => (
  <Modal isOpen onClose={() => {}}>
    <ModalOverlay />
    <ModalContent justifyContent="center" py={12} px={4}>
      <Icon as={InfoSvg} color="M.70" width="96px" height="96px" mx="auto" />
      <ModalHeader
        data-testid="dialog-title"
        fontSize="xl"
        textAlign="center"
        pb={1}
        pt={8}
        lineHeight={1.2}
        title={subtitle}
      >
        {subtitle}
      </ModalHeader>
      <ModalBody data-testid="dialog-content" p={0}>
        <Text fontSize="md" textAlign="center" data-testid="dialog-text">
          {text}
        </Text>
      </ModalBody>
    </ModalContent>
  </Modal>
);
